'use strict';

import fixedHeaderGhostHeight from './modules/fixed-header-ghost.js'
import changeLogoOnScroll from './modules/change-logo-on-scroll.js'
import smoothscrollinternallinks from './modules/smoothscrollinternallinks.js'
import popupActionButtons from './modules/popupactionbuttons.js'
import openDropdownNavigation from './modules/open-dropdown-navigation.js'
import showSearchNavigation from './modules/show-search-navigation.js'
import resizeGridItemHeights from './modules/resize-grid-item-heights.js'
import wysiwygFormatting from './modules/wysiwyg-formatting.js'
import mobileMenuNavCollapseExtension from './modules/mobile-menu-nav-collapse-extension.js'

$(document).ready(function () {
    // bootstrap's tooltips
    $(function () {
        $('[data-toggle="tooltip"]').tooltip();
    });
    fixedHeaderGhostHeight();
    changeLogoOnScroll();
    openDropdownNavigation();
    showSearchNavigation();
    smoothscrollinternallinks();
    resizeGridItemHeights();
    popupActionButtons();
    wysiwygFormatting();
    mobileMenuNavCollapseExtension();
    //tooltip for all anchors that open in new window
    setTimeout(function () {
        $('a[target=_blank]').each(function () {
            $(this).attr('title', 'Opens in a new window')
                .attr('aria-label', 'This link Opens in a new window');
        });
    }, 500);
    // WowJs
    new WOW().init();
});

$(window).on('load', function () {
    fixedHeaderGhostHeight();
    resizeGridItemHeights();
});

$(window).on('resize', function () {
    fixedHeaderGhostHeight();
    resizeGridItemHeights();
});
